@if (hasValidPointer() || interactive) {
  <div class="partner-map-section" style="margin-bottom:24px;">
    <h3>Lokalizacja na mapie</h3>
    <div #mapContainer class="map-container"></div>
    @if (mapView && isMobile) {
      <div class="map-controls">
        <div class="view-controls">
          @if (satelliteView) {
            <button mat-stroked-button color="primary" (click)="switchToNormalView()"
              [title]="'Zwykła mapa'">
              <mat-icon>map</mat-icon>
              <span class="button-text">Zwykła mapa</span>
            </button>
          }
          @if (!satelliteView) {
            <button mat-stroked-button color="primary" (click)="switchToSatelliteView()"
              [title]="'Widok satelitarny'">
              <mat-icon>satellite</mat-icon>
              <span class="button-text">Widok satelitarny</span>
            </button>
          }
          <button mat-stroked-button color="primary" (click)="showCurrentLocation(true)" [title]="'Pobierz lokalizację'">
            <mat-icon>my_location</mat-icon>
            <span class="button-text">Pobierz lokalizację</span>
          </button>
          <button mat-stroked-button color="primary" (click)="navigateToPointer()" [title]="'Nawiguj'">
            <mat-icon>directions</mat-icon>
            <span class="button-text">Nawiguj</span>
          </button>
          <button mat-stroked-button color="primary" (click)="clearRoute()" [title]="'Wyczyść trasę'">
            <mat-icon>clear</mat-icon>
            <span class="button-text">Wyczyść trasę</span>
          </button>
        </div>
      </div>
    }
  </div>
}
